import '../App.css';
import {useState,useEffect} from 'react'; 
import Loader from '../Loader'; 
import image from '../Images/codechef_logo.jpg'; 
import Header from '../Header'; 
import { PageType } from '../Constants';
function Codechef(){
         const [data,setData]=useState(null);
         const [img,Setimg]=useState(image);  
         useEffect(()=>{
            fetch('https://kontests.net/api/v1/code_chef').then((data)=>data.json()).then((response)=>{  
                   setData(response);  
            });
         },[]);
         useEffect(()=>{
          window.scrollTo(0,0);
      },[]);
    return (
        <>
        {data==null ? <Loader/> : null}
        {data != null && <>
        <Header Pagetype={PageType.CONTEST_PAGE} Title={"CodeChef Contests"} /> 
        {data.map((Data)=>
        <div className="card"> 
             <div className="img-div">
                  <img className="img" src={img} title="Codechef"></img>  
             </div>
             <div className="divbody">   
                  <p className="card-title">{Data.name}</p>  
                  <a href={Data.url} target="_blank"><button className="btn">Enter</button></a>  
             </div>
        </div> 
        )}
        </>
      }
     </>  
    );
}
export default Codechef;  